import { keyframes, styled } from '@innowise-group/mui-kit';

// The fire of https://codepen.io/RominaMartin/pen/KrqMVw without the wood. The pen's slow ±10% breathing
// is invisible at 12px, so the flames grow up to a third, sway and flicker faster
const flicker = keyframes`
  0% {
    opacity: 0.85;
    transform: scale(0.85, 0.8) rotate(-4deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.05, 1.15) rotate(3deg);
  }
  100% {
    opacity: 0.9;
    transform: scale(1.2, 1.35) rotate(-2deg);
  }
`;

const glow = keyframes`
  from {
    filter: drop-shadow(0 0 1px rgba(255, 98, 52, 0.4));
  }
  to {
    filter: drop-shadow(0 0 4px rgba(255, 125, 23, 0.9));
  }
`;

// Sizes and offsets are percents of the fire box. Each layer has its own pace, so the fire never repeats in step
const FLAMES = {
  back: { color: '#ff6234', size: 100, left: 0, bottom: 0, duration: 0.9, delay: -0.4 },
  medium: { color: '#ff7d17', size: 80, left: 10, bottom: 5, duration: 0.7, delay: -0.2 },
  front: { color: '#ffb726', size: 60, left: 20, bottom: 10, duration: 0.5, delay: 0 },
};

export type FlameLayer = keyof typeof FLAMES;

export const Fire = styled.span`
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 0.75rem;
  height: 1rem;
  margin-left: 0.5rem;
  animation: ${glow} 0.8s ease-in-out infinite alternate;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// Scales and sways a drop around its bottom, so the fire grows upwards and the title does not move
export const Flame = styled.span<{ $layer: FlameLayer }>`
  position: absolute;
  left: ${({ $layer }) => FLAMES[$layer].left}%;
  bottom: ${({ $layer }) => FLAMES[$layer].bottom}%;
  width: ${({ $layer }) => FLAMES[$layer].size}%;
  padding-bottom: ${({ $layer }) => FLAMES[$layer].size}%;
  transform-origin: 50% 100%;
  animation: ${flicker} ${({ $layer }) => FLAMES[$layer].duration}s ease-in-out infinite alternate;
  animation-delay: ${({ $layer }) => FLAMES[$layer].delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// A drop: a square with one sharp corner turned upwards
export const Drop = styled.span<{ $layer: FlameLayer }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 0 75% 75% 75%;
  background-color: ${({ $layer }) => FLAMES[$layer].color};
  transform: rotate(45deg);
`;
